const namespace = '[UI]';
export const UI_SET_LOADING = `${namespace} SET_LOADING`;
export const UI_SET_SAVING = `${namespace} SET_SAVING`;
